<template>
  <div class="jumbotron">
    <h1 class="display-4">
      Unauthorized Access
    </h1>

    <div class="lead">
      You don’t have the permission to go here.
    </div>

    <hr>

    <p>
      <slot />
      <router-link :to="{ name: 'search' }">
        Back to Search
      </router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: "UnauthorizedAccess",
  computed: {
    hasSlot() {
      return this.$slots['default'];
    }
  }
};
</script>
